import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CourseContentComponent } from './courseContent.component';
import { Shell } from '@app/shell/shell.service';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'potentialife-course/:cycleNumber/:moduleNumber/:stepNumber',
      component: CourseContentComponent,
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class CourseContentRoutingModule {}
